import { compose, lifecycle, withStateHandlers, withProps } from 'recompose';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { connect } from 'react-redux';
import { webShopCloseTime, mini } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import moment from 'moment';
import styles from './styles.module.scss';

export const updateTime = () => () => ({ currentTime: new Date() });

export function componentDidMount() {
  this.interval = setInterval(() => {
    this.props.updateTime();
  }, 60000);
}

export function componentWillUnmount() {
  clearInterval(this.interval);
}

const mapStateToProps = combineSelectors({
  webShopCloseTime,
  mini,
});

export const withFormattedClose = withProps(
  ({ webShopCloseTime, currentTime }) => {
    let formattedTimeToClose;
    let isWebShopClosed = true;
    let end = moment.utc(webShopCloseTime);
    let now = moment.utc(currentTime);
    let diffDays = end.diff(now, 'days');
    let diffHours = end.diff(now, 'hours') - diffDays * 24;
    let diffMinutes =
      end.diff(now, 'minutes') - diffDays * 24 * 60 - diffHours * 60;
    if ((diffDays < 0) | (diffHours < 0) | (diffMinutes < 0)) {
      isWebShopClosed = true;
    } else {
      formattedTimeToClose = `${diffDays}d : ${diffHours}h : ${diffMinutes}m`;
      isWebShopClosed = false;
    }
    return { formattedTimeToClose, isWebShopClosed };
  },
);

export const webshopClosedContainerStyle = ({ mini }) =>
  mini ? styles.mainMiniWebshopClosed : styles.mainWebshopClosed;

export const webshopOpenContainerStyle = ({ mini }) =>
  mini ? styles.mainMiniWebshopOpen : styles.mainWebshopOpen;

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['closed', 'timePrefix', 'timeSuffix'] }),
  connect(mapStateToProps),
  withStateHandlers(() => ({ currentTime: new Date() }), { updateTime }),
  addProps({ webshopClosedContainerStyle, webshopOpenContainerStyle }),
  lifecycle({ componentDidMount, componentWillUnmount }),
  withFormattedClose,
);
